import { render } from "./BMRCalculator.vue?vue&type=template&id=26b91568&scoped=true"
import script from "./BMRCalculator.vue?vue&type=script&lang=js"
export * from "./BMRCalculator.vue?vue&type=script&lang=js"

import "./BMRCalculator.vue?vue&type=style&index=0&id=26b91568&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b91568"]])

export default __exports__